















































































































































































import type { PropType } from "vue"
import type { stadium_business_info } from "@/@types/stadium/stadium"
import { Vue } from "vue-property-decorator"
import moment from "moment"

export default Vue.extend({
  name: "StadiumInfoForm",
  props: {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    editable: { type: Boolean, required: true },
    form    : { type: Object as PropType<stadium_business_info> },
    correct : { type: Object, default() { return {} } },
    show    : { type: Object,
      default() {
        return {
          all                  : true,
          business_time_a      : true,
          business_time_p      : true,
          business_time_o      : true,
          work_days_price_low  : true,
          work_days_price_high : true,
          business_bill_count  : true,
          business_bill_hour   : true,
          business_month_cost  : true,
          business_finance_info: true,
        }
      }
    }
  },
  data() {
    return {
      data  : {} as any,
      change: {} as any,
      area  : [] as string[],
      time  : {
        a: { start: null as moment.Moment | null, end  : null as moment.Moment | null },
        p: { start: null as moment.Moment | null, end  : null as moment.Moment | null }
      },
      rules: {
        business_time_a      : { required: true, message: "营业时间不能为空", trigger: "blur" },
        business_time_p      : { required: true, message: "营业时间不能为空", trigger: "blur" },
        work_days_price_low  : { required: true, message: "最低价格不能为空", trigger: "blur" },
        work_days_price_high : { required: true, message: "最高价格不能为空", trigger: "blur" },
        business_bill_count  : { required: true, message: "请填写每日订单量", trigger: "blur" },
        business_bill_hour   : { required: true, message: "合计时长不能为空", trigger: "blur" },
        business_month_cost  : { required: true, message: "经营成本不能为空", trigger: "blur" },
        business_finance_info: { required: true, message: "财务数据不能为空", trigger: "blur" },
      },
      cost_label: ["人力成本：", "管理软件：", "订场平台：", "其他运营：", '月合计：'],
      finance: [
        { index: 0, year: "0", revenue: "0", profit: "0" },
        { index: 1, year: "0", revenue: "0", profit: "0" },
        { index: 2, year: "0", revenue: "0", profit: "0" },
      ],
      change_finance: [
        { index: 0, year: "0", revenue: "0", profit: "0" },
        { index: 1, year: "0", revenue: "0", profit: "0" },
        { index: 2, year: "0", revenue: "0", profit: "0" },
      ],
      columns: [
        { align: "center", title: "年度", scopedSlots: { customRender: 'year' } },
        { align: "center", title: "年营业收入", scopedSlots: { customRender: 'revenue' } },
        { align: "center", title: "年净利润", scopedSlots: { customRender: 'profit' } },
      ],
    }
  },
  computed: {
    if_correct() {
      return (key: string): string => {
        let is_correct = ""
        if (Object.prototype.hasOwnProperty.call(this.form, key) && Object.prototype.hasOwnProperty.call(this.change, key)) {
          if (this.change.id && this.change.id > 0) is_correct = ""
          else is_correct = "is_correct"
        }
        // if (key == "business_time_o") console.log(key, this.form[key], this.change[key])
        return is_correct
      }
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        const data = this.$deep_copy(this.form)
        /* for (const key in data) {
          if (Object.prototype.hasOwnProperty.call(data, key) && Object.prototype.hasOwnProperty.call(this.correct, key)) {
            data[key] = this.correct[key]
          }
        } */
        // 处理营业时间
        if (data.business_time_a != "") {
          const am = data.business_time_a.split('-')
          this.time.a = { start: moment(am[0], "HH:mm"), end: moment(am[1], "HH:mm") }
        }
        if (data.business_time_p != "") {
          const pm = data.business_time_p.split('-')
          this.time.p = { start: moment(pm[0], "HH:mm"), end: moment(pm[1], "HH:mm") }
        }
        // 处理经营成本
        if (data.business_month_cost.length < 5) {
          for (let i = data.business_month_cost.length; i < 5; i += 1) data.business_month_cost.push("0")
        }
        // 处理财务数据
        for (const k in data.business_finance_info) {
          if (this.finance[k]) {
            const temp = data.business_finance_info[k].split(",")
            this.finance[k] = { index: Number(k), year: temp[0], revenue: temp[1], profit: temp[2] }
          }
        }
        this.data = data
      })
    },
    onCellChange(i: number, t: string, e: any) {
      const source = [...this.finance];
      const target = source[i]
      if (target) {
        target[t] = e.target.value;
        this.finance = source;
      }
    },
    show_correct(key: string): boolean {
      let correct = false
      if (Object.prototype.hasOwnProperty.call(this.form, key) && Object.prototype.hasOwnProperty.call(this.change, key)) {
        if (this.change.id && this.change.id > 0) correct = true
        else correct = false
      }
      return correct
    },
    submit() {
      if (this.time.a.start && this.time.a.end) this.data.business_time_a = `${this.time.a.start.format("HH:mm")}-${this.time.a.end.format("HH:mm")}`
      if (this.time.p.start && this.time.p.end) this.data.business_time_p = `${this.time.p.start.format("HH:mm")}-${this.time.p.end.format("HH:mm")}`
      const params = this.$deep_copy(this.data)
      params.business_month_cost = params.business_month_cost.join(";")
      const finance = []
      for (const v of this.finance) {
        const temp = [v.year, v.revenue, v.profit]
        finance.push(temp.join(","))
      }
      params.business_finance_info = finance.join(";")
      const form = this.$refs.form as any
      form.validate((valid: boolean) => {
        if (valid) {
          params.estimate_id = this.id
          this.$emit("modify", params)
        }
      })
    },
    check(): boolean {
      let checked = false
      const form = this.$refs.form as any
      form.validate((valid: boolean) => {
        checked = valid
      })
      return checked
    },
  },
  watch: {
    time: {
      handler() {
        if (this.time.a.start && this.time.a.end) this.data.business_time_a = `${this.time.a.start.format("HH:mm")}-${this.time.a.end.format("HH:mm")}`
        if (this.time.p.start && this.time.p.end) this.data.business_time_p = `${this.time.p.start.format("HH:mm")}-${this.time.p.end.format("HH:mm")}`
      },
      deep: true
    },
    finance: {
      handler() {
        const finance = []
        for (const v of this.finance) {
          const temp = [v.year, v.revenue, v.profit]
          finance.push(temp.join(","))
        }
        this.data.business_finance_info = finance.join(";")
      },
      deep: true
    },
    data: {
      handler() {
        this.$nextTick(() => {
          if (!this.correct.id) this.submit()
          this.change = this.$deep_copy(this.correct)
          if (this.change.business_finance_info != "") {
            const finance = this.change.business_finance_info
            for (const k in finance) {
              if (finance[k]) {
                const v = String(finance[k])
                const temp = v.split(",")
                this.change_finance[k] = ({ index: Number(k), year: temp[0], revenue: temp[1], profit: temp[2] })
              }
            }
          }
        })
      },
      deep   : true
    }
  }
})

